/**
 * Constants for the App Library Search app.
 */

export const LANG = {
  EN: 'en',
  ES: 'es',
} as const;

export type Lang = (typeof LANG)[keyof typeof LANG];

/**
 * Normalize an HTML lang attribute value to a supported Lang.
 * Maps variants like 'es-US', 'es-MX' → 'es'; defaults to 'en'.
 */
export function normalizeLang(htmlLang: string): Lang {
  const lower = htmlLang.toLowerCase();
  if (lower === 'es' || lower.startsWith('es-')) {
    return LANG.ES;
  }
  return LANG.EN;
}

export const FACETS = {
  PRICE_TYPE: 'app_price_type',
  PLATFORMS: 'app_platforms',
  CONDITION: 'app_condition',
  FEATURES: 'app_key_features',
} as const;

export type FacetKey = (typeof FACETS)[keyof typeof FACETS];

export const SORT_BY = {
  TITLE_ASC: 'title_asc',
  TITLE_DESC: 'title_desc',
  PRICE_ASC: 'price_asc',
  PRICE_DESC: 'price_desc',
} as const;

export const PARAMS = {
  KEYWORD: 'keyword',
  PAGE: 'page',
  LIMIT: 'limit',
  SORT_BY: 'sort_by',
  PRICE_TYPE: 'price_type',
  PLATFORMS: 'platforms',
  CONDITION: 'condition',
  FEATURES: 'features',
} as const;
